module.exports = __webpack_public_path__ + "fonts/Prompt-ExtraBold.45f79fce.ttf";